module.exports = __webpack_public_path__ + "img/tankLeft.b272d9b7.svg";